import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import ListProposition from "../../components/ListProposition";
import { columns } from "./columns";
import { loadRequetes, updateRequete } from "../../store/actions/requeteAction";
import { loadRequeteLots } from "../../store/actions/requeteLotAction";

class Propositions extends Component {
  componentDidMount() {
    this.props.loadRequetes();
    this.props.loadRequeteLots();
  }

  syncRequetesLots = () => {
    this.props.loadRequeteLots();
  };

  render() {
    const { requetes, requeteLots } = this.props;

    return (
      <Spin spinning={!requeteLots} size="large" tip="Chargement en cours..." wrapperClassName="view-spin">
        <ListProposition
          requetes={requetes}
          listData={
            requeteLots &&
            requeteLots.filter((item) => item.requete_lot_requete.requete_fin === false)
          }
          tableOption={columns}
          addPanesRequete={this.props.addPanesRequete}
          updateRequete={this.props.updateRequete}
          syncRequetesLots={this.syncRequetesLots}
          titre={true}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadRequetes: () => dispatch(loadRequetes()),
    loadRequeteLots: () => dispatch(loadRequeteLots()),
    updateRequete: (jsonData, id) => dispatch(updateRequete(jsonData, id)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    requetes: state.requetes.data,
    requeteLots: state.requetesLots.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Propositions);
